export default __webpack_public_path__ + "static/media/swiftly-610.6640ed1e.wav";